import React from 'react';
import { toServer } from '../../util/ServerSocket';

export function LockedInventoryPage({ id, pages, cost }: { id: number; pages: number; cost: number | null }) {
  const [confirming, setConfirming] = React.useState(false);
  const [pending, setPending] = React.useState(false);
  const [error, setError] = React.useState('');
  const request = React.useRef(false);
  const timer = React.useRef<number>();
  React.useEffect(() => () => window.clearTimeout(timer.current), []);
  const next = id === pages && cost !== null;

  function purchase() {
    if (!next || request.current) return;
    request.current = true;
    setPending(true);
    setError('');
    timer.current = window.setTimeout(() => {
      request.current = false;
      setPending(false);
      setError('เซิร์ฟเวอร์ไม่ตอบสนอง กรุณาลองอีกครั้ง');
    }, 10000);
    // The server checks the expected next page and calculates the price itself.
    toServer('unlockInventoryPage', { location: id }, (reply?: { success?: boolean; error?: string }) => {
      window.clearTimeout(timer.current);
      request.current = false;
      setPending(false);
      setConfirming(false);
      if (!reply?.success) setError(reply?.error ?? 'ไม่สามารถเปิดหน้ากระเป๋าได้ กรุณาลองอีกครั้ง');
    });
  }

  return <div style={{ position: 'absolute', inset: 0, color: '#fff', background: '#333', borderRadius: 3 }}>
    <div aria-hidden="true" style={{ position: 'absolute', inset: 0, display: 'grid', gridTemplateColumns: 'repeat(10, 1fr)', gridTemplateRows: 'repeat(6, 1fr)', gap: 1 }}>
      {Array.from({ length: 60 }, (_, i) => <div key={i} style={{ border: '1px solid #555', borderRadius: 2, background: '#393939' }} />)}
    </div>
    <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 6, gap: 6, textAlign: 'center', background: 'rgba(0,0,0,.15)', fontSize: 12 }}>
      {!confirming ? <button disabled={!next || pending} onClick={() => { setError(''); setConfirming(true); }}
        style={{ border: 0, background: 'transparent', color: '#fff', fontWeight: 'bold', textDecoration: next ? 'underline' : 'none', cursor: next ? 'pointer' : 'default', padding: 4 }}>
        {next ? `คลิกเพื่อจ่าย ${cost} โกลด์ เพื่อเปิดใช้งาน!` : `กรุณาเปิดกระเป๋าหน้า ${pages + 1} ก่อน`}
      </button> : <>
        <div role="dialog" aria-label="ยืนยันเปิดหน้ากระเป๋า">เปิดกระเป๋าหน้า {id + 1} ใช้ {cost} โกลด์</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button disabled={pending} onClick={purchase}>{pending ? 'กำลังเปิด...' : 'ยืนยัน'}</button>
          <button disabled={pending} onClick={() => setConfirming(false)}>ยกเลิก</button>
        </div>
      </>}
      {error && <div role="alert" style={{ color: '#ffb4aa', background: '#222', padding: 3 }}>{error}</div>}
    </div>
  </div>;
}
